import { DEVICE_INFO_UPDATE } from './deviceInfo.actionTypes';

export const deviceInfoUpdate = (isMobileScreen: boolean) => ({
  type: DEVICE_INFO_UPDATE,
  payload: {
    isMobileScreen,
  },
}) as const;
